import { __generator } from "tslib";
import { call, put } from 'redux-saga/effects';
import { normalizeDeviations } from '../../redux/normalizr/helpers';
import { withOffset } from '../../Stream';
import { request } from '../../xhr';
export function fakeResponse(_a) {
    var params = _a.params;
    if (process.env.NODE_ENV !== 'production') {
        var deviationsByType = require('@wix/da-sample-data').deviationsByType; // eslint-disable-line global-require
        var Chance = require('chance').Chance; // eslint-disable-line global-require
        if (window.doError) {
            return {
                error: 'invalid_request',
                error_description: 'Not logged in.',
                status: 'error',
            };
        }
        var randomDeviations = new Chance().pickset(deviationsByType.tiers, 10);
        return {
            hasMore: false,
            results: randomDeviations,
        };
    }
}
function fetch(url, params) {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call(request, {
                    method: 'get',
                    url: url,
                    params: params,
                }, fakeResponse)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response];
        }
    });
}
function handleTierStreamFetch(action) {
    var streamId, response, results, normalized;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                streamId = action.streamId;
                return [4 /*yield*/, call(fetch, 'tier/user/list', {})];
            case 1:
                response = _c.sent();
                if (!!response) return [3 /*break*/, 3];
                return [4 /*yield*/, put(withOffset.actions.fetchFailure({
                        streamId: streamId,
                        errorMsg: 'Failed to fetch',
                    }))];
            case 2:
                _c.sent();
                return [2 /*return*/];
            case 3:
                results = response.results;
                normalized = results && normalizeDeviations(results);
                return [4 /*yield*/, put(withOffset.actions.fetchSuccess({
                        streamId: streamId,
                        hasMore: false,
                        items: (_a = normalized === null || normalized === void 0 ? void 0 : normalized.result) !== null && _a !== void 0 ? _a : [],
                        entities: (_b = normalized === null || normalized === void 0 ? void 0 : normalized.entities) !== null && _b !== void 0 ? _b : {},
                    }))];
            case 4:
                _c.sent();
                return [2 /*return*/];
        }
    });
}
export default handleTierStreamFetch;
//# sourceMappingURL=tierStreamFetch.js.map